/* HTOM LIVELY — button motion, scroll-revealed Add to cart, section reveal */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) return; // no JS enhancement => everything stays visible
  root.classList.add('htom-js');

  var BTN = 'button, a.button, [role="button"], input[type="submit"], a[class*="__cta"], a[class*="__view"], .header__icon';
  var CTA = '.quick-add__submit, [class*="__quick-add"], .htom-quick-add';
  var CARD = '.card-wrapper, article, [class*="__card"], .htom-card-cell, .product-card-wrapper';

  /* ---------- 1) Reveal Add-to-cart when its product enters the screen ---------- */
  var cardIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var card = en.target;
      cardIO.unobserve(card);
      card.classList.add('is-in');
      var ctas = card.querySelectorAll('.htom-cta');
      ctas.forEach(function (b, i) {
        b.style.transitionDelay = (260 + i * 90) + 'ms';
        // wait until the card itself has settled a little, then show the button
        setTimeout(function () {
          b.classList.add('is-shown');
          setTimeout(function () { b.style.transitionDelay = ''; }, 1000);
        }, 120);
      });
    });
  }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });

  /* ---------- 2) Section reveal ---------- */
  var secIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); secIO.unobserve(en.target); }
    });
  }, { threshold: 0.06 });

  function prepare(scope) {
    scope = scope || doc;
    scope.querySelectorAll(BTN).forEach(function (b) { b.classList.add('htom-btn'); });

    scope.querySelectorAll(CTA).forEach(function (b) {
      if (b.classList.contains('htom-cta')) return;
      b.classList.add('htom-cta', 'htom-btn');
      var card = b.closest(CARD);
      if (card) {
        card.classList.add('htom-card-pop');
        cardIO.observe(card);
      } else {
        // no recognisable card: reveal when the button itself is reached
        cardIO.observe(b);
        b.addEventListener('htom-self', function () {});
      }
    });

    scope.querySelectorAll('#MainContent .shopify-section').forEach(function (s, idx) {
      if (s.classList.contains('htom-rv') || idx === 0) return;      // keep the first screen instant
      if (s.getBoundingClientRect().top < window.innerHeight * 0.7) return;
      s.classList.add('htom-rv');
      secIO.observe(s);
    });
  }

  /* CTAs that have no card ancestor: show them when they intersect */
  var selfIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-shown'); selfIO.unobserve(en.target); }
    });
  }, { threshold: 0.5 });
  var origObserve = cardIO.observe.bind(cardIO);
  cardIO.observe = function (el) {
    if (el.classList && el.classList.contains('htom-cta')) { selfIO.observe(el); return; }
    origObserve(el);
  };

  /* ---------- 3) Ripple on every button ---------- */
  doc.addEventListener('pointerdown', function (e) {
    if (reduce) return;
    var b = e.target.closest && e.target.closest('.htom-btn');
    if (!b || b.disabled || b.classList.contains('header__icon')) return;
    var cs = getComputedStyle(b);
    if (cs.position === 'static') b.style.position = 'relative';
    b.classList.add('htom-ripple-host');
    var r = b.getBoundingClientRect(), size = Math.max(r.width, r.height);
    var s = doc.createElement('span');
    s.className = 'htom-ripple';
    s.style.cssText = 'width:' + size + 'px;height:' + size + 'px;left:' + (e.clientX - r.left - size / 2) + 'px;top:' + (e.clientY - r.top - size / 2) + 'px';
    b.appendChild(s);
    setTimeout(function () { s.remove(); }, 700);
  }, { passive: true });

  /* ---------- 4) Quick add for buttons we injected (flash deals etc.) ---------- */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.htom-quick-add');
    if (!b || b.disabled) return;
    var id = b.getAttribute('data-variant-id');
    if (!id) return;
    var label = b.textContent;
    b.disabled = true;
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return fetch('/cart.js').then(function (c) { return c.json(); });
    }).then(function (cart) {
      b.classList.add('is-added'); b.textContent = '✓';
      doc.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (n) { n.textContent = cart.item_count; });
      try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'htom-quick-add', cartData: cart }); } catch (err) {}
      setTimeout(function () { b.classList.remove('is-added'); b.textContent = label; b.disabled = false; }, 1600);
    }).catch(function () {
      b.textContent = '!'; setTimeout(function () { b.textContent = label; b.disabled = false; }, 1400);
    });
  });

  /* ---------- run + watch for dynamically loaded products (filters, pagination, quick-add modals) ---------- */
  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; prepare(doc); }); }
  prepare(doc);
  new MutationObserver(schedule).observe(doc.body, { childList: true, subtree: true });
  window.addEventListener('load', schedule);
})();
